import {drawerAnatomy as parts} from '@chakra-ui/anatomy'
import {createMultiStyleConfigHelpers} from '@chakra-ui/styled-system'
import {remCalc} from '../../_utils'

// eslint-disable-next-line @typescript-eslint/unbound-method
const {definePartsStyle, defineMultiStyleConfig} = createMultiStyleConfigHelpers(parts.keys)

const filterVariant = definePartsStyle({
    header: {
        display: 'flex',
        flexDir: 'row',
        justifyContent: 'center',
        alignItems: 'flex-end',
        position: 'relative',
        width: {
            lg: remCalc(470),
            md: remCalc(470),
            sm: '100%',
            base: '100%',
        },
        height: remCalc(51),
        marginTop: remCalc(24),
        flexShrink: 0,
        color: 'text.default',
        borderBottom: 'solid 1px',
        borderColor: 'border.light',
    },
    overlay: {},
    dialogContainer: {},
    dialog: {
        display: 'flex',
        flexDir: 'column',
        alignItems: 'center',
        height: {
            lg: '100vh',
            md: '100vh',
            sm: '90vh',
            base: '100%',
        },
        width: {
            lg: remCalc(470),
            md: remCalc(470),
            sm: '100%',
            base: '100%',
        },
        minWidth: {
            lg: remCalc(470),
            md: remCalc(470),
            sm: '100%',
            base: '100%',
        },
        borderTopRadius: ['large.lg'],
    },
    closeButton: {
        width: 'iconsSize.medium',
        height: 'iconsSize.medium',
        p: remCalc(4),
    },
    body: {
        display: 'flex',
        width: {
            lg: remCalc(470),
            md: remCalc(470),
            sm: '100%',
            base: '100%',
        },
        minWidth: {
            lg: remCalc(470),
            md: remCalc(470),
            sm: '100%',
            base: '100%',
        },
        height: {
            base: '100%',
            sm: '100%',
            md: '100%',
            lg: '100%',
        },
        flexDir: 'column',
        alignItems: 'flex-start',
        gap: remCalc(22),
        color: 'text.default',
    },
    footer: {
        width: {
            lg: remCalc(470),
            md: remCalc(470),
            sm: '100%',
            base: '100%',
        },
        height: remCalc(123),
        display: 'flex',
        flexDir: 'column',
        alignItems: 'flex-start',
        gap: remCalc(11),
        px: remCalc(16),
        py: remCalc(12),
    },
})

export default defineMultiStyleConfig({
    variants: {
        filter: filterVariant,
    },
})
